import { render, staticRenderFns } from "./ModuloDeEscalas.vue?vue&type=template&id=c819927a&"
import script from "./ModuloDeEscalas.vue?vue&type=script&lang=js&"
export * from "./ModuloDeEscalas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports